






import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component} from "vue-property-decorator";
import BarChart from "../components/barchart/index.vue";
import {DashboardStore} from "@/modules/dashboard/store";

@Component({
    name: "ChartLading",
    components: {BarChart}
})
export default class extends mixins(CommonMixin) {
    get chartLading() {
        return DashboardStore.chartLading;
    }

    get label() {
        return 'Vận đơn'
    }

    get labels() {
        return this.chartLading?.map(data => data.date);
    }

    get options() {
        return {
            responsive: true,
            maintainAspectRatio: false
        }
    }

    get chartData() {
        return {
            labels: this.labels,
            datasets: [
                {
                    label: this.label,
                    backgroundColor: '#f87979',
                    data: this.chartLading?.map(data => data.value)
                }
            ]
        }
    }

    get myStyles () {
        return {
            height: `${300}px`,
            position: 'relative'
        }
    }
}
